import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

export default function AdminPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats')
      .then(res => setStats(res.data))
      .catch(err => {
        if (err.response?.status === 403) {
          navigate('/dashboard');
        } else {
          setError('Failed to load admin stats.');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) return <div style={{ padding: 24 }}>Loading admin stats…</div>;
  if (error) return <div style={{ padding: 24, color: '#DC2626' }}>{error}</div>;
  if (!stats) return null;

  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Admin</h1>
      <p style={{ color: '#6B7280', fontSize: 13, marginBottom: 24 }}>{stats.note}</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 32 }}>
        <StatCard label="Total Users" value={stats.totalUsers} />
        <StatCard label="Credits Used (recent)" value={stats.totalCreditsUsedRecent} />
        {Object.entries(stats.planBreakdown).map(([plan, count]) => (
          <StatCard key={plan} label={`${plan.charAt(0).toUpperCase()}${plan.slice(1)} Plan`} value={count} />
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: 24 }}>
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Recent Signups</h2>
          <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6B7280', borderBottom: '1px solid #E5E7EB' }}>
                <th style={{ padding: '6px 8px' }}>Email</th>
                <th style={{ padding: '6px 8px' }}>Plan</th>
                <th style={{ padding: '6px 8px' }}>Credits</th>
                <th style={{ padding: '6px 8px' }}>Via</th>
                <th style={{ padding: '6px 8px' }}>Signed up</th>
              </tr>
            </thead>
            <tbody>
              {stats.recentSignups.map((u, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #F3F4F6' }}>
                  <td style={{ padding: '6px 8px' }}>{u.email}</td>
                  <td style={{ padding: '6px 8px' }}>{u.plan}</td>
                  <td style={{ padding: '6px 8px' }}>{u.credits}</td>
                  <td style={{ padding: '6px 8px' }}>{u.signup_method}</td>
                  <td style={{ padding: '6px 8px' }}>{new Date(u.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Top Tools Used</h2>
          <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6B7280', borderBottom: '1px solid #E5E7EB' }}>
                <th style={{ padding: '6px 8px' }}>Tool</th>
                <th style={{ padding: '6px 8px' }}>Uses</th>
              </tr>
            </thead>
            <tbody>
              {stats.topTools.map((t, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #F3F4F6' }}>
                  <td style={{ padding: '6px 8px' }}>{t.action}</td>
                  <td style={{ padding: '6px 8px' }}>{t.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: 10, padding: 16 }}>
      <div style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 800 }}>{(value ?? 0).toLocaleString()}</div>
    </div>
  );
}
